export default "__VITE_ASSET__BejXRz2w__"